import request from '@/utils/request'

const CLIENT_ROUTE = 'api/v1/client/'
export const getClients = async() =>
  request({
    url: CLIENT_ROUTE + 'list',
    method: 'get'
  })

export const getClient = async(id: number) =>
  request({
    url: CLIENT_ROUTE + `${id}`,
    method: 'get'
  })

export const getClientProducts = async(id: number) =>
  request({
    url: CLIENT_ROUTE + `${id}/products`,
    method: 'get'
  })

export const createClient = async(id: number, data: any) =>
  request({
    url: CLIENT_ROUTE + `${id}/create`,
    method: 'post',
    data
  })

export const deleteClient = async(id: number) =>
  request({
    url: CLIENT_ROUTE + `${id}/deactivate`,
    method: 'post'
  })

export const updateClient = (id: number, data: any) =>
  request({
    url: CLIENT_ROUTE + `${id}/update`,
    method: 'post',
    data
  })

export const deleteClientProduct = async(clientId: number, productId: number) =>
  request({
    url: CLIENT_ROUTE + `${clientId}/products/${productId}/deactivate`,
    method: 'post'
  })

export const updateClientProduct = async(clientId: number, productId: number, data: any) =>
  request({
    url: CLIENT_ROUTE + (productId === 0
      ? `${clientId}/products/add`
      : `${clientId}/products/${productId}/update`),
    method: 'post',
    data
  })
